import { ESP_TRANSLATION_KEYS } from '../../../configs/translations'
import { TEspRequestStatus } from '../../../model/types'
import { TEspBadgeVariant } from '../../espBadge/EspBadge'

export const REQUEST_STATUS_TO_BADGE: Record<TEspRequestStatus, TEspBadgeVariant> = {
  pending: 'pending',
  approved: 'positive',
  rejected: 'negative',
}

export const REQUEST_STATUS_LABEL_KEYS: Record<TEspRequestStatus, string> = {
  pending: ESP_TRANSLATION_KEYS.admin.statusPending,
  approved: ESP_TRANSLATION_KEYS.admin.statusApproved,
  rejected: ESP_TRANSLATION_KEYS.admin.statusRejected,
}
